import { setCSRFheaders } from './es6/utils.js'
import { apiTrackQuoteRequest, pricingTrackQuoteRequest } from './es6/tracking.js'

if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function assign(target, varArgs) {
            // .length of function is 2
            'use strict'
            if (target === null || target === undefined) {
                throw new TypeError('Cannot convert undefined or null to object')
            }

            var to = Object(target)

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index]

                if (nextSource !== null && nextSource !== undefined) {
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey]
                        }
                    }
                }
            }
            return to
        },
        writable: true,
        configurable: true,
    })
}

$(document).ready(function () {
    $('body').on('change', '[name="billing_freq"]', function () {
        'use strict'

        if ($('[name="billing_freq"]:checked').val() === 'yearly') {
            $('[data-billing-freq="true"]').html('year')

            $('[data-price="true"]').each(function () {
                $(this).html($(this).attr('data-yearly-price'))
            })
        } else {
            $('[data-billing-freq="true"]').html('month')

            $('[data-price="true"]').each(function () {
                $(this).html($(this).attr('data-monthly-price'))
            })
        }
    })

    $('body').on('change', '[name="switch_view"]', function () {
        'use strict'

        $('table').toggleClass('extended_view')
    })

    $('body').on('submit', '[data-submit-form]', function (event) {
        'use strict'
        event.preventDefault()

        var button

        var dataSubmitFormObject = $(this)
        var dataSubmitForm = dataSubmitFormObject.attr('data-submit-form')

        var successMessage

        var postData
        var ajaxHandlerType

        switch (dataSubmitForm) {
            case 'custom_plan_request':
                const captchaToken = $('[name="recaptcha_token"]').val()

                button = $(this).find('button[type="submit"]')
                ajaxHandlerType = 'eversign_custom_plan_request_form'
                postData = {
                    api_requests: $(this).find('[name="cp_api_requests"]').val(),
                    templates: $(this).find('[name="cp_templates"]').val(),
                    team_members: $(this).find('[name="cp_team_members"]').val(),
                    full_name: $(this).find('[name="cp_full_name"]').val(),
                    email_address: $(this).find('[name="cp_email_address"]').val(),
                    company_name: $(this).find('[name="cp_company_name"]').val(),
                    message: $(this).find('[name="cp_message"]').val(),
                    token: captchaToken,
                }
                successMessage =
                    'Thank you for your custom plan request. Our team will be in touch with you shortly.'

                break
        }

        button.removeClass('loading')

        var error = false

        $(this)
            .find('[data-validate="required"]')
            .each(function () {
                if (!$(this).val()) {
                    $(this).addClass('error')
                    error = true
                } else {
                    $(this).removeClass('error')
                }
            })

        if (!isEmail($(this).find('[data-validate="email"]').val())) {
            $(this).find('[data-validate="email"]').addClass('error')
            error = true
        } else {
            $(this).find('[data-validate="email"]').removeClass('error')
        }

        if (error === true) {
            generalInfo(
                'show',
                'error',
                'There were errors. Please amend all fields and try again.',
            )
            return false
        }

        button.addClass('loading')
        generalInfo('hide')

        setCSRFheaders()

        var ajaxOptions = function (postData, onSuccess) {
            return {
                type: 'POST',
                url: '/php/public_ajax_handler.php?type=' + ajaxHandlerType,
                data: { postArray: JSON.stringify(postData) },
                dataType: 'json',
                error: function (XMLHttpRequest, textStatus, errorThrown) {
                    //alert(textStatus + ', ' + errorThrown);
                },
                success: function (data) {
                    button.removeClass('loading')
                    if (data.success === 1) {
                        generalInfo('show', 'success', successMessage)

                        if (onSuccess) {
                            onSuccess()
                        }

                        if (dataSubmitForm === 'custom_plan_request') {
                            // remove the form on success to prevent re-submitting

                            const currentPage = $('[name="current_page"]').val()
                            if (currentPage === 'pricing') {
                                pricingTrackQuoteRequest(
                                    postData.team_members,
                                    postData.templates,
                                    postData.api_requests,
                                )
                            }

                            if (currentPage === 'api') {
                                apiTrackQuoteRequest(
                                    postData.api_requests,
                                    postData.templates,
                                    postData.team_members,
                                )
                            }

                            dataSubmitFormObject.remove()
                        }
                    } else {
                        generalInfo('show', 'error', data.message)
                        return false
                    }
                },
            }
        }

        $.ajax(ajaxOptions(postData))
    })

    /* VALIDATE EMAIL */
    function isEmail(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/
        return regex.test(email)
    }

    /* GENERAL PANEL ERROR INFO SUCCESS MESSAGE */
    function generalInfo(showHide, type, message) {
        'use strict'

        if (showHide === 'hide') {
            $('.alert.dynamic').remove()
        } else if (showHide && type && message) {
            $('aside#alerts').html('<p class="alert ' + type + ' dynamic">' + message + '</p>')
        }
    }
})
